







import echarts, { EChartOption } from 'echarts'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from '@/components/Charts/mixins/resize'

export interface ILineChartData {
  expectedData: number[]
  actualData: number[]
}

interface DataPoint {
  name: string;
  value: (string | number)[];
}

@Component({
  name: 'TotalMachineHoursTimeSeries'
})
export default class extends mixins(ResizeMixin) {
  @Prop({ default: 'chart' }) private className!: string
  @Prop({ default: '100%' }) private width!: string
  @Prop({ default: '350px' }) private height!: string
  data: any[] = [];
  now: Date = new Date(2020, 1, 1);
  oneDay = 24 * 3600 * 1000;
  // value = Math.random() * 1000;
  value = 217;

  // @Watch('chartData', { deep: true })
  // private onChartDataChange(value: ILineChartData) {
  //   this.setOptions(value)
  // }

  mounted() {
    this.$nextTick(() => {
      for (let i = 0; i < 200; i++) {
          let randData = this.randomData();
          this.data.push(randData);
      }
      this.initChart()
    })
  }

  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }

  randomData(): DataPoint {
      this.now = new Date(+this.now + this.oneDay);
      this.value = this.value + (Math.random() * 21 - 10)/2;
      return {
          name: this.now.toString(),
          value: [
              [this.now.getFullYear(), this.now.getMonth() + 1, this.now.getDate()].join('/'),
              Math.round(this.value)
          ]
      }
  }

  private initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, 'macarons')
    this.setOptions()
  }

  private setOptions() {
    if (this.chart) {
      this.chart.setOption({
      tooltip: {
          trigger: 'axis',
          formatter: function(data: any) {
              let params = data[0];
              var date = new Date(params.name);
              return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' : ' + params.value[1] + ' Hours';
          },
          axisPointer: {
              animation: false
          }
      },
      grid: {
        top: '10%',
        left: '2%',
        right: '5%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
          type: 'time',
          splitLine: {
              show: false
          },
          axisLabel: {
            formatter: function(value: string, idx: number) {
                var date = new Date(value);
                return idx === 0 ? value : [date.getMonth() + 1, date.getFullYear()].join('-');
            }
          }
      },
      yAxis: {
          type: 'value',
          boundaryGap: false
      },
      series: [{
          name: 'Daily Hours',
          type: 'line',
          showSymbol: false,
          hoverAnimation: false,
          data: this.data
      }]
      } as EChartOption<EChartOption.SeriesLine>)
    }
  }
}
